export function createCanvasAdapter(options = {}) {
  const { preferOffscreen = true, doc = (typeof document !== 'undefined' && document) || null } =
    options

  function createCanvas(width = 1, height = 1) {
    // Prefer OffscreenCanvas when available and allowed
    if (preferOffscreen && typeof OffscreenCanvas !== 'undefined') {
      try {
        const c = new OffscreenCanvas(width, height)
        c.width = width
        c.height = height
        return c
      } catch (e) {
        // fallthrough to DOM canvas
      }
    }

    if (!doc) throw new Error('No document available to create a canvas')
    const c = doc.createElement('canvas')
    c.width = width
    c.height = height
    return c
  }

  function createDOMCanvas(width = 1, height = 1) {
    if (!doc) throw new Error('No document available to create a DOM canvas')
    const c = doc.createElement('canvas')
    c.width = width
    c.height = height
    return c
  }

  function getContext(canvas, type = '2d', options = {}) {
    if (!canvas) return null
    return canvas.getContext(type, options)
  }

  function resizeCanvas(canvas, width, height) {
    if (!canvas) return canvas
    canvas.width = width
    canvas.height = height
    return canvas
  }

  function toImageData(canvas) {
    const ctx = getContext(canvas, '2d')
    if (!ctx) return null
    return ctx.getImageData(0, 0, canvas.width, canvas.height)
  }

  return {
    createCanvas,
    createDOMCanvas,
    getContext,
    resizeCanvas,
    toImageData
  }
}

export default { createCanvasAdapter }
